﻿import React, {JSX} from "react";
import {MvvmPrefixedControlProps} from "./MvvmControlProps";
import MvvmInput from "./MvvmInput";

export type MvvmNumberInputProps<T extends object = never> = MvvmPrefixedControlProps<T, number> & {
	max?: number;
	min?: number;
	step?: number;
};

export default function MvvmNumberInput<T extends object = never>(props: MvvmNumberInputProps<T>): JSX.Element {
	return <MvvmInput<T, number> control={props}
	                             type={"number"}
	                             updateOnChange={true}
	                             max={props.max}
	                             min={props.min}
	                             step={props.step}
	                             valueToString={function (value: number | undefined): string {
		                             return value == null || isNaN(value) ? "" : value.toString();
	                             }}
	                             valueFromString={function (value: string | undefined): number {
		                             return value == null ? 0 : parseFloat(value);
	                             }}/>;
};
